import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';
import utils from './../../library'



class ShopMenu extends Component {
constructor(props){
    super()
}

componentDidMount(){
utils.loadOwnerColors()
}
    render(props){
    console.log(props)

    
        return ( 
        <div className="Shop_row">        
            <div className="Shop_menu_panel dark darkblue">
            <span className="Shop_menu_item lhover lighthover" onClick={() => this.props.setMode("userbook")}>📘</span><span className="Shop_menu_item lhover lighthover" onClick={() => this.props.setMode("default")}>📦</span><span className="Shop_menu_item  lhover lighthover" onClick={() => this.props.setMode("meta")}>🐣</span><span className="Shop_menu_item lhover lighthover" onClick={() => this.props.setMode("instructions")}>🌈</span>
               <span className="Shop_menu_item lhover lighthover right" onClick={() => this.props.update("Book")}>🏰</span><span className="Shop_menu_item lhover lighthover right">🎪</span>
               <div className="clear"></div>
                     
            </div>
        </div>
            
        );
    }


}



        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default ShopMenu